import type { ChangeEvent, ReactElement, ReactNode } from 'react';
import { Component } from 'react';
import styles from './styles.module.css';

export interface InputFileProps {
  children: NonNullable<ReactNode>;
  name: string;
  accept?: string;
  disabled?: boolean;
  multiple?: boolean;
  onFileUpload: (e: ChangeEvent<HTMLInputElement>) => void;
}

export class InputFile extends Component<InputFileProps> {
  handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    if (e.target.files && e.target.files.length > 0) {
      this.props.onFileUpload(e);
    }
    // Empty the input file value, so that the same file can be uploaded twice in a row.
    e.target.value = '';
  };

  render(): ReactElement {
    const { children, name, accept, disabled, multiple } = this.props;
    return (
      <div className={styles.InputFileContainer}>
        <label htmlFor={name}>{children}</label>
        <input
          type="file"
          disabled={disabled}
          className={styles.InputHidden}
          id={name}
          accept={accept}
          multiple={multiple}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}
